import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp, isWHWP2 } from '../../../../components/common/Helpers/index.js';

const cartAddons = Loadable(() =>
  isFuncComp() || isWHWP2() ? import('../../containers/FunctionalRedesign/cartAddons') : import('../../containers/web/cartAddons'),
);

export default MapTo('vcg/components/soe-home/react/cartAddons')(cartAddons);
